module.exports = __webpack_public_path__ + "static/media/feedback-success.bf45fd3f.png";